/* Added-to-basket panel (<cart-notification>). Moved out of snippets/cart-notification.liquid so it is
 * cached instead of re-sent in every page's HTML. Markup + styles stay in the snippet. */
  (function () {
    if (customElements.get('cart-notification')) return;

    // --- pure helpers: mirrored verbatim from tests/cart-notification.mjs ---
    // Change there, run `node --test`, then mirror here.

    // Is checkout being held? TWO independent signals, and either one holds:
    //
    //   b2b-cart-verifying — b2b-pricing.js: the displayed price is being confirmed.
    //   b2b-promo-gating   — the promo freshness gate in discount-codes.liquid: the cart is not
    //                        yet stamped as priced (no b2b_price_sig for the live cart).
    //
    // The second is NOT implied by the first. b2b-pricing.js clears `verifying` when its sync
    // finishes whether or not a stamp was written — a worker failure and an under-informed
    // response both end with no stamp — so `verifying` alone lets this panel reach checkout
    // with unpriced lines while the gate is correctly still holding. This panel cannot be
    // covered by the gate's own guards: the control is [data-cn-checkout], not
    // button[name="checkout"], and submitCheckout() uses form.submit(), which fires no
    // submit event.
    //
    // This must be the ONLY place the two signals are combined — see onCheckout().
    function b2bHoldActive(verifying, gating) {
      return !!(verifying || gating);
    }

    // The line total to show from the LOCAL tier price book, or null when it must not be used.
    //
    // b2b-pricing.js already holds the customer's whole catalogue sku->price map, in pence, in
    // sessionStorage. So the toast can name the trade price with NO round trip, instead of
    // shimmering for the ~6s the server takes to confirm it. Verified on a wholesale account: the
    // map said 599 for wkpme000 and the cart charged 599.
    //
    // It is an ESTIMATE, and the cap is what keeps it honest. The map is the customer's TIER
    // price; the cart charges best-of(tier, promo, quantity break, override) and skips excluded
    // products. So it can read HIGH -- a promo beats the tier, and the number corrects down, which
    // is harmless -- and, rarely, LOW, when the product is excluded from B2B, which would correct
    // upward. Refusing anything not strictly BELOW the retail line price removes the above-retail
    // case outright. The rest is bounded: this is a provisional value superseded within seconds,
    // and nobody can transact on it because the checkout gate holds independently until prices are
    // confirmed.
    //
    // NOT a revival of applyCartPrices(), which is dead on purpose -- that wrote the same estimate
    // into the DRAWER, a surface people check out from.
    function tierLinePrice(unitPence, quantity, retailLinePence) {
      if (typeof unitPence !== 'number' || !(unitPence > 0)) return null;
      var qty = quantity > 0 ? quantity : 1;
      var line = unitPence * qty;
      if (typeof retailLinePence === 'number' && retailLinePence > 0 && line >= retailLinePence) return null;
      return line;
    }

    // Pence -> the string shape the drawer's `money` filter renders, so a later confirmed read of
    // the same number compares EQUAL to the estimate and neither repaints nor restarts the
    // countdown.
    function formatGBP(pence) {
      return '£' + (pence / 100).toFixed(2);
    }

    // Is the number the drawer is showing the number the customer will be charged?
    //
    // `b2b:cart-synced` is NOT that signal, however much it reads like one. b2b-pricing.js
    // dispatches it at the end of EVERY completed sync, including ones that priced nothing.
    // Measured on www, guest, first add (t = add click):
    //
    //   t+1101  /cart/add.js returns; the drawer section it rendered is at RETAIL
    //   t+1387  b2b:cart-synced #1      ← concluded nothing; the Worker has not been called
    //   t+2944  Worker /api/prices/cart-discounts responds
    //   t+3332  /cart/update.js?sections=cart-drawer lands — the drawer is NOW tier-priced
    //
    // The one signal that does mean it is the hold the checkout button already waits on:
    // b2b-pricing.js keeps `b2b-cart-verifying` up until confirmDisplayThenRelease() has
    // compared the DISPLAYED total against the real cart, and the promo gate keeps
    // `b2b-promo-gating` up until the cart is stamped as priced. Either one down-tools the
    // display; both clear means the drawer is telling the truth.
    //
    // The failsafe is not optional: b2b-pricing.js releases its own hold after 8s whatever
    // happens, and a panel that waited longer than the code it is waiting on would shimmer
    // forever on a hung sync.
    function priceIsFinal(held, failsafeExpired) {
      return !held || !!failsafeExpired;
    }

    // Not mirrored (touches the DOM); kept here so the two call sites read identically.
    function hasClass(name) {
      return !!(document.body && document.body.classList.contains(name));
    }

    // Not mirrored (reads document.cookie). Does this shopper buy at a trade price?
    //
    // Deliberately the `b2b_tier` COOKIE rather than a tag test of our own. b2b-tier-cookie.liquid
    // writes that cookie ONLY for a customer who passes the trade gate -- bare `b2b`, or a tag
    // listed in shop.metafields.b2b.tier_tags -- so reusing it cannot drift from the gate, and a
    // brand-new tier tag is covered the day it is added. Re-implementing the test here would
    // also have to know that `platinum b2b` is NOT `b2b` (the gate is an exact match).
    //
    // Read at settle time, not at IIFE time: the cookie is written by a script in <head> that
    // may not have run when this element is defined.
    // The tier price book b2b-pricing.js already fetched, or null.
    //
    // Read straight out of sessionStorage rather than asking b2b-pricing.js: it keeps the map in
    // its IIFE closure and exposes nothing on window, and adding an export there would mean
    // touching an asset with no test harness at all. The cache key and its 15-minute TTL are
    // mirrored from assets/b2b-pricing.js (getCacheKey / readCache) — if either changes there
    // this returns null and the panel simply falls back to shimmering, which is the safe
    // direction, not a wrong price.
    function readTierPrices() {
      try {
        var cid = (window.__b2b_customer_id != null) ? String(window.__b2b_customer_id) : 'guest';
        var suffix = '_' + cid;
        for (var i = 0; i < sessionStorage.length; i++) {
          var k = sessionStorage.key(i);
          if (!k || k.indexOf('b2b_prices_') !== 0) continue;
          if (k.slice(-suffix.length) !== suffix) continue;   // another customer's cache
          var c = JSON.parse(sessionStorage.getItem(k));
          if (!c || !c.timestamp || !c.skuPrices) return null;
          if (Date.now() - c.timestamp > 15 * 60 * 1000) return null;
          return c.skuPrices;
        }
      } catch (e) {
        // sessionStorage blocked, or malformed JSON — fall back to the shimmer.
      }
      return null;
    }

    function isTradeShopper() {
      return /(?:^|;\s*)b2b_tier=[^;\s]/.test(document.cookie || '');
    }

    function thumbUrl(url) {
      if (!url) return '';
      var q = url.indexOf('?');
      var base = q === -1 ? url : url.slice(0, q);
      var qs = q === -1 ? '' : url.slice(q);
      var dot = base.lastIndexOf('.');
      if (dot === -1) return url;
      return base.slice(0, dot) + '_160x' + base.slice(dot) + qs;
    }

    function buildItemSummary(item) {
      var opts = (item && item.options_with_values) || [];
      var values = opts
        .map(function (o) { return o && o.value; })
        .filter(function (v) { return v && v !== 'Default Title'; });

      return {
        key: (item && item.key) || '',
        variantId: (item && item.variant_id) || null,
        title: (item && item.product_title) || '',
        variantLabel: values.join(' / '),
        quantity: (item && item.quantity) || 0,
        image: thumbUrl(item && item.image),
        imageRaw: (item && item.image) || '',
        url: (item && item.url) || '',
        price: null,
        sku: (item && item.sku) || '',
        retailLinePrice: (item && item.original_line_price) || 0,
        isSubstitute: !!(item && item.properties && item.properties._substitute_for),
        // Human label for what this line stands in for. The line's own variant
        // title cannot be used: it matches only when both ranges name the
        // variant identically (shades do, developer strengths do not --
        // "20 Vol (6%)" against "20V 6%").
        substituteFor: (item && item.properties && item.properties._substitute_for_name) || ''
      };
    }

    // The mobile "this is a swap" banner. Returns null for every ordinary line —
    // the caller renders nothing at all rather than an empty box.
    //
    // Returns the two product names as SEPARATE fields so the panel can set them at
    // display size, the sold-out one struck through. An earlier draft returned one
    // sentence led by "the same shade number, at the same price"; that emphasises
    // sameness, which is backwards — the shopper has to notice the tube arriving
    // says a different brand. The reassurance is demoted to `note`.
    function swapBannerCopy(item) {
      var props = (item && item.properties) || {};
      if (!props._substitute_for) return null;

      var sku = props._substitute_for_sku || '';
      var isShade = /^(LCP|P09LC)/i.test(sku);

      // The bulk shade modal writes only the id and the sku, so the human name is
      // routinely absent. Fall back to a phrase, never to the raw sku.
      var askedFor = props._substitute_for_name ||
        (isShade ? 'the shade you chose' : 'the item you chose');

      // product_title is the full catalogue name ("3deluxe Professional Permanent
      // Hair Colour 100ml"), which wraps to three lines at display size and stops
      // being a contrast. The leading brand token carries the difference; the full
      // title is still in the product row directly below.
      var brand = String((item && item.product_title) || '').split(' ')[0];
      var values = (((item && item.options_with_values) || [])
        .map(function (o) { return o && o.value; })
        .filter(function (v) { return v && v !== 'Default Title'; }));
      var getting = [brand].concat(values).join(' ').trim();

      return {
        askedFor: askedFor,
        getting: getting,
        note: (isShade ? 'same shade number' : 'same strength') + ' · same price',
      };
    }

    function shadeProductUrl(item) {
      var opts = (item && item.options_with_values) || [];
      var isShade = opts.some(function (o) { return o && o.name === 'Shade'; });
      if (!isShade) return null;

      var url = (item && item.url) || '';
      if (!url) return null;
      return url.split('?')[0];
    }

    function pickLinePrice(texts) {
      var clean = (texts || [])
        .map(function (t) { return (t || '').trim(); })
        .filter(function (t) { return t.length > 0; });
      return clean.length ? clean[clean.length - 1] : null;
    }

    // How long the panel will wait for pricing to conclude before painting whatever the
    // drawer says and letting go. Matches b2b-pricing.js's own failsafe and onCheckout()'s
    // poll cap, so no surface waits longer than the code it is waiting on.
    var SETTLE_FAILSAFE_MS = 8000;

    // The PROVISIONAL deadline: how long the cell shimmers before the panel will paint a
    // number that pricing has not yet confirmed. It is no longer the moment the panel stops
    // listening — priceIsFinal() decides that — only the moment it stops holding a number
    // back. A confirmed price is always painted immediately, deadline or not.
    //
    // A sold-out-shade substitute keeps the LONGER deadline. An unconfirmed number on an
    // ordinary line is merely the pre-discount price of the right product; on a substitute it
    // is the price of a DIFFERENT product, because the held price exists only after the cart
    // round-trips to the Worker -- a wholesale customer saw £5.49 on a line that charges
    // £1.90 and read it as the substitution having failed.
    // NOBODY gets an early provisional number anymore -- trade or guest. A TRADE shopper never
    // did: theirs is the public price, the precise thing that reads as "my trade discount did
    // not apply". Until 2026-09 a GUEST did (hasB2BPricing ? 1500 : 0), on the assumption that
    // an unconfirmed drawer read is always retail and retail is always a guest's correct price.
    // That broke the day a promo started pricing guests too -- b2b-pricing.js's own comment:
    // "promotions with b2b_only=0 are available to ALL customers including retail and anonymous
    // visitors". A guest adding a promo'd line (e.g. a product-level "Koleston £7.37" offer) saw
    // the pre-promo £8.50 flash for ~1.5-3s before it corrected, which is exactly the "reads as
    // my discount did not apply" failure the trade guard already exists to prevent. A shimmer
    // says "confirming"; a retail figure states a falsehood confidently -- for either audience
    // now. `hasB2BPricing` still gates 0 vs the failsafe: when the pricing script is not even on
    // the page, nothing will ever confirm or hold, so there is nothing to wait for. In practice
    // this is not a long wait: priceIsFinal() releases the moment the holds clear (~4s
    // measured), and the failsafe is only the ceiling.
    function settleDelay(hasB2BPricing, isSubstitute, isTrade) {
      if (isSubstitute) return 6000;
      return hasB2BPricing ? SETTLE_FAILSAFE_MS : 0;
    }


    function panelTop(headerBottom) {
      var GAP = 12;
      if (typeof headerBottom !== 'number') return GAP;
      return Math.max(GAP, headerBottom + GAP);
    }

    var DISMISS_MS = 10000;

    function shouldRunDismissTimer(state) {
      if (!state) return false;
      return !!state.settled && !state.interacting;
    }
    // --- end mirrored helpers ---

    var HAS_B2B = !!document.querySelector('script[src*="b2b-pricing"]');

    customElements.define('cart-notification', class CartNotification extends HTMLElement {
      constructor() {
        super();
        this.panel = this.querySelector('.cn__panel');
        this.settleTimer = null;
        // The settle is a repeating read, not a one-shot — see settle() / watchSettle().
        this.settlePoll = null;
        this.settleStarted = null;
        this.deadlinePassed = false;
        this.estimated = false;
        this.priceText = '';
        this.subtotalText = '';
        this.onSynced = this.settle.bind(this);

        this.querySelector('[data-cn-close]').addEventListener('click', this.close.bind(this));
        this.querySelector('[data-cn-checkout]').addEventListener('click', this.onCheckout.bind(this));

        this.shadeBtn = this.querySelector('[data-cn-shades]');
        this.shadeUrl = null;
        this.swap = null;
        if (this.shadeBtn) this.shadeBtn.addEventListener('click', this.onShades.bind(this));

        // Reading the panel holds it open. Pointer and keyboard both count, so a
        // keyboard user tabbing through it is never timed out mid-read.
        this.interacting = false;
        this.settled = false;
        ['mouseenter', 'focusin'].forEach(function (evt) {
          this.addEventListener(evt, function () {
            this.interacting = true;
            this.syncDismissTimer();
          }.bind(this));
        }, this);
        ['mouseleave', 'focusout'].forEach(function (evt) {
          this.addEventListener(evt, function () {
            this.interacting = false;
            this.syncDismissTimer();
          }.bind(this));
        }, this);

        this.onKeydown = function (e) { if (e.key === 'Escape') this.close(); }.bind(this);
        // One stable reference so add/removeEventListener actually pair up.
        this.onRepositionBound = this.onReposition.bind(this);
        this.repositionFrame = null;

        // The header cart icon (theme.js:949 `.mbCart`) opens the drawer by adding
        // classes directly, bypassing CartDrawer.open() — so nothing else would
        // dismiss us and the panel would float over the drawer's overlay.
        document.addEventListener('click', function (e) {
          if (e.target.closest && e.target.closest('.mbCart') && !this.hidden) this.close();
        }.bind(this), true);
      }

      // ProductForm asks for this and posts the ids to /cart/add.js.
      // `cart-drawer` stays in the list so the drawer, its B2B prices and the
      // promo gate all keep updating — we just never open it.
      getSectionsToRender() {
        return [{ id: 'cart-drawer', selector: '#CartDrawer' }];
      }

      setActiveElement(element) { this.activeElement = element; }

      // Swap the drawer's contents and update the header badge from the same
      // parsed document. The badge count rides on #CartDrawer[data-cart-count]
      // rather than a second section, so there is nothing to render twice and
      // nothing to go stale if a section id ever changes.
      applyDrawerHTML(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('#CartDrawer');
        var dest = document.querySelector('#CartDrawer');
        if (!fresh || !dest) return;

        dest.innerHTML = fresh.innerHTML;

        var count = fresh.getAttribute('data-cart-count');
        dest.setAttribute('data-cart-count', count || '');
        var badge = document.querySelector('#CartCount');
        if (badge && count !== null) badge.textContent = count;

        var freshWrapper = doc.querySelector('cart-drawer');
        var drawer = document.querySelector('cart-drawer');
        if (drawer && freshWrapper) {
          drawer.classList.toggle('is-empty', freshWrapper.classList.contains('is-empty'));
        }
      }

      renderContents(parsedState) {
        var sections = parsedState && parsedState.sections;

        // 1. Sync the drawer + badge in the background. No open().
        if (sections && sections['cart-drawer']) this.applyDrawerHTML(sections['cart-drawer']);

        // 2. Show what we know for certain, immediately.
        //    Unhide BEFORE writing the text: a live region whose content changes
        //    while it is hidden is generally not announced.
        this.summary = buildItemSummary(parsedState);
        this.shadeUrl = shadeProductUrl(parsedState);
        this.swap = swapBannerCopy(parsedState);
        this.open();
        this.paint(this.summary);
        // Cart upsell (assets/cart-dev-popout.js) decides whether this add earns a
        // "Developers" button. The panel itself stays ignorant of the feature.
        document.dispatchEvent(new CustomEvent('cart-notification:open', { detail: { item: parsedState } }));

        // 3. Settle the price. Deliberately NOT `{ once: true }`, and deliberately not the
        //    timer alone — see priceIsFinal() and watchSettle(). Either would paint the
        //    RETAIL price the add.js drawer render carried and never look again.
        this.pending();
        this.settleStarted = Date.now();
        document.addEventListener('b2b:cart-synced', this.onSynced);
        clearTimeout(this.settleTimer);
        var self = this;

        // A trade shopper gets their price NOW, off the local book, rather than a shimmer or —
        // worse — the public price. A substitute is excluded: its held price is not the added
        // variant's own tier price, so the local book would name the wrong number entirely.
        var trade = isTradeShopper();
        this.estimated = (trade && !(this.summary && this.summary.isSubstitute))
          ? this.paintEstimate()
          : false;

        this.settleTimer = setTimeout(
          function () { self.deadlinePassed = true; self.settle(); },
          settleDelay(HAS_B2B, this.summary && this.summary.isSubstitute, trade)
        );
        this.watchSettle();

        this.loadRecommendations(parsedState.product_id);
      }

      paint(s) {
        var img = this.querySelector('[data-cn-image]');
        if (s.image) {
          // The _160x filename convention does not hold for every CDN URL shape,
          // so fall back to the untransformed URL once before giving up.
          img.onerror = function () {
            img.onerror = null;
            if (s.imageRaw && img.getAttribute('src') !== s.imageRaw) {
              img.src = s.imageRaw;
            } else {
              img.hidden = true;
            }
          };
          img.hidden = false;
          img.src = s.image;
        } else {
          img.removeAttribute('src');
          img.hidden = true;
        }

        this.querySelector('[data-cn-title]').textContent = s.title;

        var variant = this.querySelector('[data-cn-variant]');
        variant.textContent = s.variantLabel;
        variant.hidden = !s.variantLabel;

        // Must be set on EVERY render, not just when true — the panel element is
        // reused between adds, so a substitute add followed by an ordinary one
        // would otherwise leave the note showing on the wrong product.
        var subst = this.querySelector('[data-cn-subst]');
        if (subst) {
          var forEl = subst.querySelector('[data-cn-subst-for]');
          if (forEl) forEl.textContent = s.substituteFor || ('the ' + (s.variantLabel || '') + ' you chose');
          subst.hidden = !s.isSubstitute;
        }

        // Same "set on EVERY render" rule as the callout above: the element is
        // reused, so an ordinary add after a substitute add must clear it.
        var swapEl = this.querySelector('[data-cn-swap]');
        if (swapEl) {
          var swap = this.swap;
          if (swap) {
            swapEl.querySelector('[data-cn-swap-was]').textContent = swap.askedFor;
            swapEl.querySelector('[data-cn-swap-now]').textContent = swap.getting;
            swapEl.querySelector('[data-cn-swap-note]').textContent = swap.note;
          }
          swapEl.hidden = !swap;
        }

        this.querySelector('[data-cn-qty]').textContent = 'Qty ' + s.quantity;

        Array.prototype.forEach.call(this.querySelectorAll('[data-cn-link]'), function (a) {
          if (s.url) { a.href = s.url; } else { a.removeAttribute('href'); }
        });

        // Offer bulk-add only for a shade product, and only when the modal is
        // actually on the page to open. The modal snippet renders on every
        // template, so the second test guards against it being removed rather
        // than against a template.
        if (this.shadeBtn) {
          this.shadeBtn.hidden = !this.shadeUrl || !document.getElementById('shade-modal');
          // Published on the button so the GA4 delegate in theme.liquid can
          // attribute the open to the product being opened, not to whatever page
          // the shopper happens to be standing on.
          if (this.shadeUrl) {
            this.shadeBtn.setAttribute('data-shade-url', this.shadeUrl);
          } else {
            this.shadeBtn.removeAttribute('data-shade-url');
          }
        }
      }

      // Straight from "added" into picking more shades of the same product.
      //
      // The modal is rendered on every template but is only BUILT for the current
      // page's product, so an add from a collection grid's quick-shop has to
      // rebuild it first. openForProduct does both and resolves only once the
      // modal is showing this product's shades; if it can't, the product page is
      // the honest fallback — opening a modal on the wrong product is worse than
      // a navigation.
      onShades() {
        var url = this.shadeUrl;
        if (!url) return;

        // hide(), not close(): close() returns focus to the add-to-cart button,
        // which is the wrong place to land when a modal is about to take over.
        this.hide();

        var api = window.BulkShadeModal;
        if (!api || typeof api.openForProduct !== 'function') { window.location = url; return; }
        api.openForProduct(url).catch(function () { window.location = url; });
      }

      pending() {
        var shimmer = '<span class="cn__shimmer" aria-hidden="true"></span>';
        this.querySelector('[data-cn-price]').innerHTML = shimmer;
        this.querySelector('[data-cn-subtotal]').innerHTML = shimmer;
        // Per-add state. Left over from the previous add these would suppress the paint of an
        // identical-looking price and, worse, treat the last add's deadline as already met.
        this.priceText = '';
        this.subtotalText = '';
        this.deadlinePassed = false;
        this.estimated = false;
      }

      // Name the trade price immediately from the local book, so a trade shopper reads their
      // own price rather than a shimmer while the server takes ~6s to confirm it. Returns true
      // when something was painted. A guest is still only called here when not a substitute
      // (see renderContents) but in practice never gets a number: b2b-pricing.js's init() skips
      // fetchPrices()/writeCache() entirely for a plain anonymous guest (no b2b_tier cookie, no
      // source-segment cookie — see its "retail/anonymous, promos-only sync" early return), so
      // readTierPrices() finds no cached book and returns false here. That is a missing LOCAL
      // book, not "retail is correct" — a promo can still discount a guest's line server-side,
      // which is why settleDelay() no longer trusts an unconfirmed drawer read for guests either.
      paintEstimate() {
        var s = this.summary || {};
        if (!s.sku) return false;
        var prices = readTierPrices();
        if (!prices) return false;

        var unit;
        for (var k in prices) {
          if (prices.hasOwnProperty(k) && k.toLowerCase() === String(s.sku).toLowerCase()) {
            unit = prices[k];
            break;
          }
        }
        var line = tierLinePrice(unit, s.quantity, s.retailLinePrice);
        if (line === null) return false;

        this.priceText = formatGBP(line);
        this.querySelector('[data-cn-price]').textContent = this.priceText;
        // Deliberately NOT the subtotal: this estimate covers the line just added, and the
        // basket total may carry other lines and order-level discounts we cannot compute here.
        // It stays shimmering until the confirmed read lands.
        this.settled = true;
        this.syncDismissTimer();
        return true;
      }

      // Watch for the moment pricing concludes. This exists because `b2b:cart-synced` is not
      // that moment (priceIsFinal explains why) and because the LAST sync of an add can take
      // _afterSync's `_pendingSync` branch, which re-queues and returns without dispatching at
      // all — so an event-only panel can be left waiting for a signal that never comes.
      // Releasing the hold always happens; it is the trustworthy trigger.
      //
      // Same predicate and same 8s cap as onCheckout(). The price cell and the checkout button
      // must never disagree about when the displayed price can be believed.
      watchSettle() {
        var self = this;
        clearInterval(this.settlePoll);
        this.settlePoll = setInterval(function () {
          if (!priceIsFinal(
            b2bHoldActive(hasClass('b2b-cart-verifying'), hasClass('b2b-promo-gating')),
            self.failsafeExpired()
          )) return;
          self.settle();
        }, 100);
      }

      failsafeExpired() {
        return this.settleStarted !== null && (Date.now() - this.settleStarted) >= SETTLE_FAILSAFE_MS;
      }

      // Read the numbers out of the rendered drawer — the same figures the customer would see
      // if they opened the basket.
      //
      // REPEATABLE BY DESIGN, and the repeat is the whole fix. As a one-shot this painted
      // whichever number the drawer happened to hold at t+1500ms and detached; on a real add
      // the re-priced drawer does not land until ~t+3300ms, so a wholesale customer was shown
      // the public price on a line charged at their tier and nothing ever corrected it.
      settle() {
        var held = b2bHoldActive(hasClass('b2b-cart-verifying'), hasClass('b2b-promo-gating'));
        var confirmed = !held;
        var isFinal = priceIsFinal(held, this.failsafeExpired());

        // Two rules, depending on whether a local estimate is already on screen.
        //
        // With one: ONLY a confirmed read may replace it. The estimate is the customer's tier
        // price; the drawer's unconfirmed figure is the PUBLIC price, so painting that over it
        // — at the deadline, or at the failsafe when pricing never concluded — would undo the
        // whole point and show retail to a trade shopper again.
        //
        // Without one: before the provisional deadline only a confirmed number may be painted,
        // which is what the deadline is for. A confirmed one is never held back.
        if (this.estimated ? confirmed : (isFinal || this.deadlinePassed)) this.paintSettled();
        if (!isFinal) return;

        // Arm the countdown even when there was nothing readable to paint. paintSettled()
        // only marks the panel settled when it actually WROTE a number, so a final settle that
        // finds no line — drawer mid-swap on exactly this tick, a key that never matched, the
        // 422 path — would otherwise detach everything and leave the panel shimmering and open
        // forever.
        this.settled = true;
        this.syncDismissTimer();
        this.stopSettling();
      }

      // Find the drawer line for the item just added.
      //
      // NOT by `key` alone. Shopify's line key is `variantId:hash`, and the hash changes when
      // the line gains a **discount allocation** — so the key `/cart/add.js` handed us is stale
      // the instant b2b-pricing.js's discount lands. Measured on a wholesale account, first add:
      //
      //   /cart/add.js returned    48698601079084:4ff522acb8ce67f7a826ff7da7eab13c
      //   the re-priced drawer had 48698601079084:a8094e3b0cc96acfcc9ee7cd3bf196fc
      //
      // Same variant, `properties` empty in both. So the lookup missed in exactly the case a
      // discount HAD been applied — invisible to guests, universal for trade — and the panel
      // kept the provisional RETAIL number. It also explains why a SECOND add of the same
      // product looked right: the discount already existed, so nothing re-keyed.
      //
      // `data-variant-id` survives the re-key. Key first, because it is the only thing that
      // separates two lines of the same variant (a sold-out-shade substitute beside an ordinary
      // one); variant id as the fallback, and ONLY when it identifies exactly one line —
      // painting some other line's price would be worse than painting none.
      findLine() {
        var s = this.summary || {};
        if (s.key) {
          var byKey = document.querySelector('#CartDrawer li.cart-item[data-key="' + s.key + '"]');
          if (byKey) return byKey;
        }
        if (!s.variantId) return null;
        var byVariant = document.querySelectorAll(
          '#CartDrawer li.cart-item[data-variant-id="' + s.variantId + '"]'
        );
        return byVariant.length === 1 ? byVariant[0] : null;
      }

      // Write only what was actually read. A repaint landing while the drawer is being
      // replaced finds no line at all, and blanking a settled number is worse than briefly
      // showing a stale one.
      paintSettled() {
        var line = this.findLine();
        var texts = line
          ? Array.prototype.map.call(line.querySelectorAll('.ctitempr .price'), function (n) { return n.textContent; })
          : [];

        var price = pickLinePrice(texts);
        var changed = false;
        if (price && price !== this.priceText) {
          this.priceText = price;
          this.querySelector('[data-cn-price]').textContent = price;
          changed = true;
        }

        var sub = document.querySelector('#CartDrawer .cart_total span:last-child');
        var subtotal = sub ? sub.textContent.trim() : '';
        if (subtotal && subtotal !== this.subtotalText) {
          this.subtotalText = subtotal;
          this.querySelector('[data-cn-subtotal]').textContent = subtotal;
          changed = true;
        }

        // The countdown runs from the moment the panel holds a number worth reading — and
        // RESTARTS when that number is corrected, so a shopper is never left with two seconds
        // to take in the price they are actually paying.
        if (changed && this.priceText) {
          this.settled = true;
          this.syncDismissTimer();
        }
      }

      stopSettling() {
        clearTimeout(this.settleTimer);
        clearInterval(this.settlePoll);
        this.settlePoll = null;
        document.removeEventListener('b2b:cart-synced', this.onSynced);
      }

      loadRecommendations(productId) {
        var recs = this.querySelector('[data-cn-recs]');
        var row = this.querySelector('[data-cn-recs-row]');
        // Absent when the "Add to cart toast recommender" setting is off — the
        // Liquid does not render the block at all, so there is nothing to fetch.
        if (!recs || !row) return;
        recs.hidden = true;
        row.innerHTML = '';
        if (!productId) return;

        var url = '/recommendations/products.json?product_id=' + productId + '&limit=3&intent=related';
        fetch(url)
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) {
            var products = (data && data.products) || [];
            if (!products.length) return;
            // Built with DOM APIs, not string concatenation — product titles are
            // merchant-authored and must never be parsed as markup.
            products.forEach(function (p) {
              if (!p.featured_image) return;
              var a = document.createElement('a');
              a.className = 'cn__rec';
              a.href = p.url;
              // Image only — the title is the accessible name, not visible text.
              // Product names here run long enough to wrap to three lines and
              // dominate the panel.
              a.title = p.title;
              a.setAttribute('aria-label', p.title);

              var figure = document.createElement('span');
              figure.className = 'cn__rec-img';
              var img = document.createElement('img');
              img.src = thumbUrl(p.featured_image);
              img.alt = '';
              figure.appendChild(img);

              a.appendChild(figure);
              row.appendChild(a);
            });
            if (!row.children.length) return;
            recs.hidden = false;
          })
          .catch(function () { /* recommendations are a bonus, never a blocker */ });
      }

      // Sit just under the live header, whatever height it currently is —
      // announcement bar, sticky header mid-animation, or scrolled away entirely.
      // Recomputed on scroll/resize while visible, since a sticky header slides
      // in and out underneath us.
      position() {
        var header = document.querySelector('#header');
        var bottom = header ? header.getBoundingClientRect().bottom : null;
        this.style.setProperty('--cn-top', panelTop(bottom) + 'px');
      }

      onReposition() {
        if (this.repositionFrame) return;
        this.repositionFrame = requestAnimationFrame(function () {
          this.repositionFrame = null;
          this.position();
        }.bind(this));
      }

      // Start, restart or cancel the auto-dismiss countdown to match current
      // state. Called whenever `settled` or `interacting` changes; the decision
      // itself lives in shouldRunDismissTimer so it stays under test.
      syncDismissTimer() {
        clearTimeout(this.dismissTimer);
        if (this.hidden) return;
        if (!shouldRunDismissTimer({ settled: this.settled, interacting: this.interacting })) return;
        this.dismissTimer = setTimeout(this.autoDismiss.bind(this), DISMISS_MS);
      }

      // Checkout, with the wait moved from the button's appearance to the click.
      //
      // TWO independent holds, and either one waits:
      //   b2b-cart-verifying — b2b-pricing.js, while the Worker re-prices the cart.
      //   b2b-promo-gating   — the promo freshness gate in discount-codes.liquid, while the
      //                        cart is not yet stamped as priced.
      // Both are honoured: submit immediately if neither is set, otherwise show a working
      // state on the button and go the moment they clear (bounded by the 8s failsafe below,
      // matching b2b-pricing.js's own, so a hung sync can never trap a customer).
      //
      // The fast path and the poll MUST read the same predicate. When each carried its own
      // condition, the fast path was left checking `verifying` alone — so in the exact state
      // this protects against (a failed sync clears `verifying` without writing a stamp) it
      // submitted immediately and never polled.
      onCheckout(e) {
        if (e) e.preventDefault();
        var btn = this.querySelector('[data-cn-checkout]');
        if (btn.getAttribute('aria-busy') === 'true') return;

        if (!b2bHoldActive(hasClass('b2b-cart-verifying'), hasClass('b2b-promo-gating'))) {
          this.submitCheckout();
          return;
        }

        var self = this;
        var original = btn.textContent;
        btn.setAttribute('aria-busy', 'true');
        btn.textContent = 'Confirming price…';

        // Match b2b-pricing.js's own failsafe (8s) so we release no later than it
        // does — waiting longer would strand the customer the gate is protecting.
        var started = Date.now();
        var poll = setInterval(function () {
          var held = b2bHoldActive(hasClass('b2b-cart-verifying'), hasClass('b2b-promo-gating'));
          if (held && Date.now() - started < 8000) return;
          clearInterval(poll);
          btn.removeAttribute('aria-busy');
          btn.textContent = original;
          self.submitCheckout();
        }, 100);
      }

      // Post the drawer's cart form with `checkout` set, which is what the theme's
      // own button does via name="checkout". form.submit() is used rather than
      // requestSubmit() so this cannot be re-blocked by b2b-pricing.js's submit
      // guard — by this point we have already satisfied the condition that guard
      // enforces.
      submitCheckout() {
        var form = document.querySelector('#CartDrawer-Form');
        if (!form) {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        if (!form.querySelector('input[name="checkout"]')) {
          var flag = document.createElement('input');
          flag.type = 'hidden';
          flag.name = 'checkout';
          flag.value = '';
          form.appendChild(flag);
        }
        form.submit();
      }

      open() {
        // Fresh add: nothing is settled yet, so the countdown stays parked until
        // settle() says there is a price on screen.
        this.settled = false;
        clearTimeout(this.dismissTimer);
        // A second add landing mid-fade must cancel the pending hide, or the
        // panel would reopen and then vanish a moment later.
        clearTimeout(this.hideTimer);

        this.hidden = false;
        this.classList.remove('cn--out');
        this.classList.add('cn--in');
        this.clearThemeLoading();
        this.position();
        document.addEventListener('keydown', this.onKeydown);
        window.addEventListener('scroll', this.onRepositionBound, { passive: true });
        window.addEventListener('resize', this.onRepositionBound, { passive: true });
        // Deliberately NOT modal: no overflow-hidden and no focus trap. The
        // shopper keeps their place in the grid.
      }

      // The collection-grid quick-add delegate (theme.js:944) sets body.loading
      // and relies on CartDrawer.open() to clear it. We are the one opening now.
      // Left set it would strand `.loading .modalOverly` (full-page scrim) and
      // `.template-collection.loading .grid-view-item { opacity: .3 }` over the
      // very grid this feature exists to keep browsable.
      clearThemeLoading() {
        document.body.classList.remove('loading');
      }

      // Shared teardown + fade. `hidden` is applied only after the transition,
      // because the [hidden] rule is display:none and would cut the fade off.
      hide() {
        clearTimeout(this.dismissTimer);
        this.stopSettling();
        document.removeEventListener('keydown', this.onKeydown);
        window.removeEventListener('scroll', this.onRepositionBound);
        window.removeEventListener('resize', this.onRepositionBound);
        if (this.repositionFrame) {
          cancelAnimationFrame(this.repositionFrame);
          this.repositionFrame = null;
        }

        this.classList.remove('cn--in');
        this.classList.add('cn--out');

        var self = this;
        clearTimeout(this.hideTimer);
        this.hideTimer = setTimeout(function () {
          self.hidden = true;
          self.classList.remove('cn--out');
        }, 200);
      }

      // User-initiated: close button, Escape, header cart icon. Focus goes back
      // to whatever they were on, because they asked for this.
      close() {
        this.hide();
        if (this.activeElement && document.contains(this.activeElement)) {
          try { this.activeElement.focus({ preventScroll: true }); } catch (e) {}
        }
      }

      // Timer-initiated. Deliberately does NOT move focus: the shopper has moved
      // on by definition, and yanking focus back to the add button ten seconds
      // later would interrupt whatever they are doing now.
      autoDismiss() {
        this.hide();
      }


      // Called by ProductForm when /cart/add.js 422s: items ARE added server-side
      // but the body carries no `sections`, so renderContents can't run.
      refresh() {
        var self = this;
        fetch('/cart?section_id=cart-drawer')
          .then(function (r) { return r.text(); })
          .then(function (text) {
            self.applyDrawerHTML(text);
            self.clearThemeLoading();
            // renderContents() never ran on this path, so there is no provisional deadline and
            // no watch running. Paint what the drawer says now — holding it back would leave
            // the PREVIOUS add's number on screen — then watch for the confirmed one exactly
            // as an ordinary add does.
            if (!self.hidden) {
              self.deadlinePassed = true;
              if (self.settleStarted === null) self.settleStarted = Date.now();
              self.paintSettled();
              self.watchSettle();
            }
          })
          .catch(function (e) { console.error(e); });
      }

      // Called by assets/cart-dev-popout.js after it adds a developer while this panel is open.
      // NOT refresh(): that is the 422 path — it forces deadlinePassed and, with the first add's
      // settleStarted long past the failsafe, settles at once on the drawer's RETAIL subtotal.
      // This swaps the drawer from the add's own `sections`, then re-arms the settle exactly as
      // renderContents() does. The line price is left alone — the panel's item has not changed;
      // only the basket total has, so only the subtotal goes back to shimmering.
      resettle(res) {
        var sections = res && res.sections;
        if (sections && sections['cart-drawer']) this.applyDrawerHTML(sections['cart-drawer']);
        if (this.hidden) return;
        this.querySelector('[data-cn-subtotal]').innerHTML = '<span class="cn__shimmer" aria-hidden="true"></span>';
        this.subtotalText = '';
        this.deadlinePassed = false;
        this.settleStarted = Date.now();
        document.addEventListener('b2b:cart-synced', this.onSynced);
        clearTimeout(this.settleTimer);
        var self = this;
        this.settleTimer = setTimeout(
          function () { self.deadlinePassed = true; self.settle(); },
          settleDelay(HAS_B2B, this.summary && this.summary.isSubstitute, isTradeShopper())
        );
        this.watchSettle();
      }
    });
  })();
